const useGetElementByClassName = (className) => {
  return {
    element: document?.getElementsByClassName(className)?.[0],
    className: document?.getElementsByClassName(className)?.[0] && className,
  };
};

export default useGetElementByClassName;
